import React, { useEffect } from "react";
import { ReactSVG } from "react-svg";
import imageLinks from "assets/images";
import { Button } from "components/ui";
import { STANDARD, WIDE } from "../ImageCropScale/enums";
import { imageCropModes, MOBILE } from "./enums";
import ComponentAccessControl from "components/essentials/ComponentAccessControl/ComponentAccessControl";
import { DEPENDENCY_BRANCH_UPDATE_PERMISSION } from "components/dashboard/TrainSAM/Dependency/permissions";
import {
    CAPSULE_DELETE_PERMISSION,
    CAPSULE_UPDATE_PERMISSION,
} from "components/dashboard/KnowledgeBase/permissions";
import {
    ISSUE_CONVERSATION_DELETE_PERMISSION,
    ISSUE_CONVERSATION_UPDATE_PERMISSION,
} from "components/dashboard/TrainSAM/SAM/WorkflowSettings/permissions";
import { baseResources, baseResourceActions } from "routes/enum";
import "./ImageCropHeader.scss";

const { AGENTS_INBOX_CONVERSATION_BREAKER } = baseResources;
const { UPDATE } = baseResourceActions;

const ImageCropHeader = ({
    cropMode,
    setCropMode,
    setSelectedScale,
    isEdit,
    handleEdit,
    handleOpenDeleteModal,
}) => {
    const handleCropMode = (mode) => {
        setCropMode?.(mode);
        setSelectedScale?.(mode === MOBILE ? STANDARD : WIDE);
    };

    useEffect(() => {
        setSelectedScale?.(cropMode === MOBILE ? STANDARD : WIDE);
        // eslint-disable-next-line
    }, [cropMode]);

    return (
        <div className='image__crop__header'>
            <div>
                <h3 className='image__crop__header--title'>Attach an image</h3>
                <span className='image__crop__header--sub__title'>
                    Select a photo and upload
                </span>
            </div>
            {isEdit ? (
                <div className='crop__actions'>
                    <ComponentAccessControl
                        baseResources={[
                            ...DEPENDENCY_BRANCH_UPDATE_PERMISSION,
                            ...CAPSULE_UPDATE_PERMISSION,
                            `${UPDATE}_${AGENTS_INBOX_CONVERSATION_BREAKER}`,
                            ...ISSUE_CONVERSATION_UPDATE_PERMISSION,
                        ]}>
                        <Button
                            text='Edit'
                            classType='plain'
                            otherClass='fw-bold edit__image-btn'
                            onClick={handleEdit}
                        />
                    </ComponentAccessControl>
                    <ReactSVG src={imageLinks?.icons?.pipe} />
                    <ComponentAccessControl
                        baseResources={[
                            ...DEPENDENCY_BRANCH_UPDATE_PERMISSION,
                            ...CAPSULE_DELETE_PERMISSION,
                            `${UPDATE}_${AGENTS_INBOX_CONVERSATION_BREAKER}`,
                            ...ISSUE_CONVERSATION_DELETE_PERMISSION,
                        ]}>
                        <ReactSVG
                            src={imageLinks?.icons?.redTrash}
                            className='crop__actions--delete'
                            onClick={handleOpenDeleteModal}
                        />
                    </ComponentAccessControl>
                </div>
            ) : (
                <div className='crop__mode__container'>
                    <ul className='crop__modes'>
                        {Object.entries(imageCropModes)?.map(
                            ([key, value], i) => (
                                <li
                                    key={i}
                                    className={`crop__mode ${
                                        key === cropMode
                                            ? "active__crop__mode"
                                            : ""
                                    } `}
                                    onClick={() => handleCropMode(key)}>
                                    {value}
                                </li>
                            )
                        )}
                    </ul>
                </div>
            )}
        </div>
    );
};

export default ImageCropHeader;
